import { render, staticRenderFns } from "./LangBar.vue?vue&type=template&id=48fb670c&scoped=true&"
import script from "./LangBar.vue?vue&type=script&lang=js&"
export * from "./LangBar.vue?vue&type=script&lang=js&"
import style0 from "./LangBar.vue?vue&type=style&index=0&id=48fb670c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fb670c",
  null
  
)

export default component.exports